import React from 'react';

const FullBooked = () => {
  return (
    <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='&#8;FullBooked_48'>
        <rect id='Rectangle 1' x='2' y='6' width='44' height='39' rx='4' fill='#EDEFF0' />
        <path
          id='Rectangle 2'
          d='M2 10C2 7.79086 3.79086 6 6 6H42C44.2091 6 46 7.79086 46 10V17H2V10Z'
          fill='#C6CACE'
        />
        <rect id='Rectangle 3' x='12' y='1' width='4' height='10' rx='2' fill='#C6CACE' />
        <rect id='Rectangle 4' x='32' y='1' width='4' height='10' rx='2' fill='#C6CACE' />
        <g id='Vector'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M30.5097 24.4903C31.1634 25.1439 31.1634 26.2038 30.5097 26.8574L19.8574 37.5097C19.2038 38.1634 18.1439 38.1634 17.4903 37.5097C16.8366 36.8561 16.8366 35.7962 17.4903 35.1426L28.1426 24.4903C28.7962 23.8366 29.8561 23.8366 30.5097 24.4903Z'
            fill='#C6CACE'
          />
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M30.5097 37.5097C29.8561 38.1634 28.7962 38.1634 28.1426 37.5097L17.4903 26.8574C16.8366 26.2038 16.8366 25.1439 17.4903 24.4903C18.1439 23.8366 19.2038 23.8366 19.8574 24.4903L30.5097 35.1426C31.1634 35.7962 31.1634 36.8561 30.5097 37.5097Z'
            fill='#C6CACE'
          />
        </g>
      </g>
    </svg>
  );
};

export default FullBooked;
